// extracted by mini-css-extract-plugin
export default {"pomodoro":"Pomodoro_pomodoro__S0CUv"};